import { INavData } from '@coreui/angular';

export const navItems2: INavData[] = [
    {
      name: 'Dashboard',
      url: '/courier/dashboard',
      icon: 'icon-puzzle'
    },
    {
      name: 'Entries',
      url: '/courier/entry',
      icon: 'icon-puzzle',
      children: [
        
        {
          name: 'Shipment Booking',
          url: '/courier/entry/bookingold',
          icon: 'icon-puzzle'
        },
        
        {
          name: 'Shipment Forwarding',
          url: '/courier/entry/forwarding',
          icon: 'icon-puzzle'
        },  
        {
          name: 'Proof Of Delivery',
          url: '/courier/entry/pod',
          icon: 'icon-puzzle'
        },
        {
          name: 'Shipment Status',
          url: '/courier/entry/podstatus',
          icon: 'icon-puzzle'
        },
        {
          name: 'RTO Entry',
          url: '/courier/entry/rto',
          icon: 'icon-puzzle'
        },
        {
          name: 'POD Upload',
          url: '/courier/entry/podupload',
          icon: 'icon-puzzle'
        },
        {
          name: 'Runsheet Upload',
          url: '/courier/entry/runsheetupload',
          icon: 'icon-puzzle'
        }
      ]},
      {
        name: 'Manifest',
        url: '/courier/manifest',
        icon: 'icon-puzzle',
        children:[
          {
            name: 'Create Manifest',
            url: '/courier/manifest/manifest',
            icon: 'icon-puzzle'
          },
          {
            name: 'View Manifest',
            url: '/courier/manifest/viewmanifest',
            icon: 'icon-puzzle'
          }
        ]
      },
      {
        name: 'Inscan',
        url: '/courier/inscan',
        icon: 'icon-puzzle',
        children: [
          {
            name: 'Inscan Manifest',
            url: '/courier/inscan/inscanmanifest',
            icon: 'icon-puzzle'
          },
          {
            name: 'Inscan AWBNo',
            url: '/courier/inscan/inscanawb',
            icon: 'icon-puzzle'
          },
          {
            name: 'Manifest Tally',
            url: '/courier/inscan/manifesttally',
            icon: 'icon-puzzle'
          }
        ]
      },
      {
        name: 'Runsheet',
        url: '/courier/drs',
        icon: 'icon-puzzle',
        children:[
          {
            name: 'Create Runsheet',
            url: '/courier/drs/drs',
            icon: 'icon-puzzle'
          },
          {
            name: 'View Runsheet',
            url: '/courier/drs/viewdrs',
            icon: 'icon-puzzle'
          }
        ]
      },
      {
        name: 'Shipment Query',
        url: '/courier/report/shipmentquery',
        icon: 'icon-puzzle'
      },
      {
        name: 'Track & Trace',
        url: '/courier/report/tracktrace',
        icon: 'icon-puzzle'
      },
      {
        name: 'Reports',
        url: '/courier/report',
        icon: 'icon-puzzle',
        children: [
          
          {
            name: 'Status',
            url: '/courier/report/status',
            icon: 'icon-puzzle'
          },
          {
            name: 'Status MIS',
            url: '/courier/report/statusmis',
            icon: 'icon-puzzle'
          },
          {
            name: 'Booking Statement',
            url: '/courier/report/bookingstatement',
            icon: 'icon-puzzle'
          },
          
          {
            name: 'Booking Summary',
            url: '/courier/report/bookingsummary',
            icon: 'icon-puzzle'
          },
          {
            name: 'Booking MIS',
            url: '/courier/report/bookingmis',
            icon: 'icon-puzzle'
          },
          {
            name: 'Check List',
            url: '/courier/report/checklist',
            icon: 'icon-puzzle'
          },
          {
            name: 'Manifest',
            url: '/courier/report/manifest',
            icon: 'icon-puzzle'
          },
          {
            name: 'UnManifest',
            url: '/courier/report/unmanifest',
            icon: 'icon-puzzle'
          },
          {
            name: 'Branch MIS',
            url: '/courier/report/branchmis',
            icon: 'icon-puzzle'
          },
          {
            name: 'CNote Print',
            url: '/courier/report/cnoteprint',
            icon: 'icon-puzzle'
          },
          {
            name: 'Invoice Print',
            url: '/courier/report/invoiceprint',
            icon: 'icon-puzzle'
          },
          {
            name: 'Label Print',
            url: '/courier/report/labelprint',
            icon: 'icon-puzzle'
          }
        ]},
        {
          name: 'Log Out',
          url: 'login',
          icon: 'icon-puzzle'
        }
    
  
  
];
